import { makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'

const Claims = () => {
  const classes = useStyles()

  return (
    <div className={classes.claimComponent} data-test='claimsComponent'>
      <div className={classes.claimColumnHeading}>
        <p
          className={`${classes.portfolioTableText} ${classes.empIdColumn}`}
          data-test='empIdHeading'
        >
          Emp ID / Name
        </p>
        <p
          className={`${classes.portfolioTableText} ${classes.claimCloumn}`}
          data-test='claimNameHeading'
        >
          Claim Name
        </p>
        <p
          className={`${classes.portfolioTableText} ${classes.claimCloumn}`}
          data-test='claimNumberHeading'
        >
          Claim Number
        </p>
        <p
          className={`${classes.portfolioTableText} ${classes.claimCloumn}`}
          data-test='claimTypeHeading'
        >
          Claim Type
        </p>
        <p
          className={`${classes.portfolioTableText} ${classes.claimCloumn}`}
          data-test='claimStatusHeading'
        >
          Claim Status
        </p>
      </div>
      <div className={classes.noClaimsSection}>
        <p className={classes.noClaimsText} data-test='noClaimsText'>
          No Claims Recorded
        </p>
      </div>
    </div>
  )
}

export default Claims

const useStyles = makeStyles({
  portfolioTableText: {
    fontWeight: '500',
    color: COLORS.GREY,
    // width: "15vw",
    marginBottom: '5px',
    marginTop: '5px',
  },
  empIdColumn: {
    width: '20vw',
  },
  claimCloumn: {
    width: '10vw',
  },
  sumInsuredTableText1: {
    fontWeight: '500',
    color: COLORS.GREY,
    width: '10vw',
    fontSize: '12px',
    marginBottom: '-1px',
    borderBottom: `0.5px solid ${COLORS.GREY_11}`,
    padding: '5px',
  },
  noClaimsSection: {
    fontSize: '12px',
    // padding: "5px 0px 0px 0px",
  },
  noClaimsText: {
    marginTop: '4%',
    fontSize: '20px',
  },
  claimColumnHeading: {
    display: 'flex',
    fontSize: '13px',
    borderBottom: `1px solid ${COLORS.BLACK01}`,
    padding: '5px 0px 0px 0px',
    backgroundColor: COLORS.LIGHT_GREY01,
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
  },
  claimComponent: {
    width: '100%',
    border: `1px solid ${COLORS.BLACK01}`,
    borderRadius: '10px',
    height: '165px',
    overflow: 'auto',
  },
})
